const optionsHTML = (radioInputs) => {
    let optionsHTML = '';

    radioInputs.forEach((radioInput) => {
        const labelText = document.querySelector(`label[for="${radioInput.id}"]`)
            .textContent;

        optionsHTML += `
            <option
                value="${radioInput.value}"
                ${radioInput.checked && 'selected'}
            >
                ${labelText}
            </option>
        `;
    });

    return optionsHTML;
};

const renderSelect = (radioButtonGroup, radioInputs) => {
    const mainLabel = radioButtonGroup.querySelector('label');
    const [{
        name, required, disabled
    }] = radioInputs;

    radioButtonGroup.classList.add('radios-as-select');

    mainLabel.setAttribute('for', `${name}-select`);

    mainLabel.insertAdjacentHTML('afterend', `
        <div class="radios-as-select-container">
            <div class="form-group form-group-select">
                <select
                    class="form-control"
                    id="${name}-select"
                    ${required && 'required'}
                    ${disabled && 'disabled'}
                    data-cs-mask
                >
                    <option value="">Please select</option>
                    ${optionsHTML(radioInputs)}
                </select>
            </div>
        </div>
    `);

    return radioButtonGroup.querySelector('select');
};

const radiosAsSelect = (selector) => {
    const formSections = document.querySelectorAll(selector);

    if (!formSections.length) {
        return;
    }

    formSections.forEach((formSection) => {
        const radioButtonGroup = formSection.closest('.form-section-radio-buttons');

        if (!radioButtonGroup) {
            return;
        }

        const radioInputs = radioButtonGroup.querySelectorAll('input');

        if (!radioInputs.length) {
            return;
        }

        const select = renderSelect(radioButtonGroup, radioInputs);

        radioInputs.forEach(radioInput =>
            radioInput.addEventListener('input', () =>
                select.value = radioInput.value
            )
        );

        select.addEventListener('input', () => {
            const radioInputsArray = [...radioInputs];
            const linkedRadioInput = radioInputsArray.find(radioInput =>
                radioInput.value === select.value
            );
            const checkedRadioInput = radioInputsArray.find(radioInput =>
                radioInput.checked
            );

            if (linkedRadioInput) {
                linkedRadioInput.click();
            } else if (checkedRadioInput) {
                checkedRadioInput.checked = false;
            }
        });

        select.addEventListener('blur', () => {
            const radioRow = radioButtonGroup.querySelector('.radio-selection-row');
            const isInvalid = !select.checkValidity();
            radioRow.classList.toggle('is-invalid', isInvalid);
            if (isInvalid) {
                const helpBlock = radioButtonGroup.querySelector('.help-block');
                select.setAttribute('aria-invalid', 'true');
                let liveRegion = document.getElementById('form-validation-announcer');
                if (!liveRegion) {
                    liveRegion = document.createElement('div');
                    liveRegion.setAttribute('id', 'form-validation-announcer');
                    liveRegion.setAttribute('aria-live', 'assertive');
                    liveRegion.setAttribute('aria-atomic', 'true');
                    liveRegion.className = 'sr-only';
                    document.body.appendChild(liveRegion);
                }
                if (helpBlock) {
                    if (!helpBlock.id) {
                        helpBlock.id = 'error-' + (select.id || select.name || Math.random().toString(36).substr(2, 9));
                    }
                    select.setAttribute('aria-describedby', helpBlock.id);
                    liveRegion.textContent = '';
                    setTimeout(() => {
                        liveRegion.textContent = helpBlock.textContent.trim();
                    }, 50);
                }
            } else {
                select.removeAttribute('aria-invalid');
                select.removeAttribute('aria-describedby');
            }
        });
    });
};

export default radiosAsSelect;
